import { FC, useEffect, useState } from "react";
import { MobileMenu } from "./MobileMenu"
import { MenuConfiguration } from "./consts";
import { MenuItemDto } from "./types";
import { getMobileMenu } from "../../api/transport/configurationTransport";
import { useConfiguration } from "../../hooks/useConfiguration";

interface MenuProps {
    collapsed?: boolean;
    onItemSelect?: (itemKey: string) => void;
}

export const Menu: FC<MenuProps> = ({
    collapsed = false,
    onItemSelect,
}) => {
    const config = useConfiguration();
    const [menu, setMenu] = useState<MenuItemDto[]>(MenuConfiguration);

    useEffect(() => {
        getMobileMenu(config.teamName).then(m => {
            if (!m?.length) {
                return;
            }

            setMenu(m);
        })
    }, [config?.teamName]);

    return (
        <MobileMenu
            collapsed={collapsed}
            items={menu}
            onItemSelect={onItemSelect}
        />
    )
}

export * from './MobileMenu';
export * from './MenuButton';